import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import TextComponent from '../../../Component/Render/Text';

export class AlphaText extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: { duration: number; startAlpha: number; endAlpha: number }
    ): IterableIterator<number> {
        const textComponent = gameObject.getComponent(TextComponent);
        const tween = this.getTween(textComponent);

        textComponent.alpha = meta.startAlpha;

        tween
            .to({ alpha: meta.endAlpha }, meta.duration)
            .easing(Easing.Linear.None);

        yield* this.startTween(tween);
    }
}
